import packageJson from "../../package.json";

export const APP_VERSION: string = packageJson.version;
export const APP_ENV = import.meta.env.VITE_APP_ENV || "development";
export const IS_PROD = APP_ENV === "production";
export const IS_DEV = APP_ENV === "development";
// Duplicated in vite.config.mts (the config cannot import this module):
// the CSP's connect-src must name the same origin the client calls, or
// every API request dies in the browser before it leaves - which is what
// happened in CI, where no .env exists.
export const API_BASE_URL =
	import.meta.env.VITE_APP_API_URL || "https://api.chronos.localhost/";
export const API_URL = `${API_BASE_URL}api/`;

// The marketing site holds the legal texts the sign-up form links to.
// Empty until the site is online: the form then names the texts without
// links, which docs/rgpd.md lists as blocking for the V2.
export const SITE_URL = (import.meta.env.VITE_APP_SITE_URL || "").replace(
	/\/+$/,
	""
);
